// Theme code editor (specs 19).
const codeEn = {
  "code.title": "Code editor",
  "code.back": "Back to themes",
  "code.files": "Files",
  "code.filter_files": "Filter files",
  "code.open_files": "Open files",
  "code.open_tab": "Open in a tab",
  "code.has_errors": "Has errors",
  "code.modified": "edited",
  "code.modified_hint": "Changed from the original theme",
  "code.file_actions": "File actions",
  "code.add_file": "Add file",
  "code.upload_asset": "Upload asset",
  "code.add_in": "Add a file to {folder}",
  "code.create": "Create file",
  "code.created": "File created",
  "code.template_type": "Template for",
  "code.template_suffix": "Alternate name",
  "code.file_name": "File name",
  "code.name_invalid": "Use lowercase letters, numbers, - and _ only.",
  "code.name_taken": "A file with this name already exists.",
  "code.will_create": "Creates",
  "code.format": "Format",
  "code.format.json": "JSON template (sections you can arrange)",
  "code.format.liquid": "Liquid template",
  "code.format.section": "Section",
  "code.format.section_group": "Section group (JSON)",
  "code.hint.layout": "The page frame around every template, e.g. theme or password.",
  "code.hint.templates": "Leave empty for the default template, or name an alternate one (product.gift → “gift”).",
  "code.hint.sections": "Starts with settings, theme blocks and a preset.",
  "code.hint.blocks": "A theme block that sections can hold. Start with _ for a private block.",
  "code.hint.snippets": "Reusable Liquid, included with {% render 'name' %}.",
  "code.hint.custom_pages": "A page layout merchants can pick for a page in Storefront › Pages.",
  "code.hint.assets": "With extension: .css, .js, .json, .svg, .txt or .liquid. Upload images, fonts and media instead.",
  "code.hint.locales": "A language code, e.g. ar or en.default.",
  "code.hint.config": "",
  "code.rename": "Rename",
  "code.rename_title": "Rename file",
  "code.rename_hint": "Files that use the old name aren't updated: check them after renaming.",
  "code.renamed": "File renamed",
  "code.duplicate": "Duplicate",
  "code.duplicate_title": "Duplicate file",
  "code.save_first": "Save or discard your changes first.",
  "code.delete": "Delete",
  "code.delete_title": "Delete file?",
  "code.delete_body": "This deletes",
  "code.used_by": "Used in {n} places — they'll break:",
  "code.no_references": "Nothing in the theme refers to this file.",
  "code.delete_history": "Its history is kept, so you can bring it back from a restore point.",
  "code.deleted_toast": "File deleted",
  "code.page": "Page",
  "code.history": "Older versions",
  "code.history_hint": "Pick a version to compare it with the editor.",
  "code.this_version": "This version",
  "code.editor_now": "In the editor now",
  "code.restore_version": "Restore this version",
  "code.version_restored": "Version restored",
  "code.restore_label": "a restored version",
  "code.current": "Current",
  "code.deleted": "deleted",
  "code.system": "System",
  "code.close": "Close",
  "code.snapshots": "Restore points",
  "code.snapshots_hint": "A restore point saves every file of the theme. The live theme gets one each day it changes; restoring first saves the current state.",
  "code.snapshot_name": "Name, e.g. Before Ramadan banner",
  "code.snapshot_create": "Create restore point",
  "code.snapshots_none": "No restore points yet.",
  "code.snapshot_auto": "Daily backup",
  "code.n_files": "{n, plural, one {# file} other {# files}}",
  "code.restore": "Restore",
  "code.snapshot_restore_title": "Restore the whole theme?",
  "code.snapshot_restore_body": "Every file goes back to “{name}”. The current state is saved as a restore point first.",
  "code.snapshot_restored": "Theme restored",
  "code.goto_file": "Go to file",
  "code.goto_file_ph": "Type part of a file name",
  "code.no_matches": "No matching files",
  "code.conflict_title": "This file changed while you were editing",
  "code.conflict_body": "{who} saved a newer version of",
  "code.conflict_clean": "Your changes and theirs don't overlap, so they were merged. Check the result and save.",
  "code.conflict_markers": "{n} places changed on both sides. They're marked with <<<<<<< and >>>>>>> — edit them on the right, then save.",
  "code.conflict_saved": "Saved by {who}",
  "code.conflict_merged": "Merged result (editable)",
  "code.conflict_theirs": "Discard mine",
  "code.conflict_mine": "Overwrite with mine",
  "code.conflict_use_merged": "Save merged",
  "code.conflict_label_mine": "your changes",
  "code.someone": "Someone",
  "code.markers_left": "Resolve the <<<<<<< ======= >>>>>>> markers before saving.",
  "code.live": "Live",
  "code.draft": "Draft",
  "code.development": "Development",
  "code.read_only": "Read only",
  "code.also_editing": "Also editing this theme",
  "code.no_file": "no file open",
  "code.wrap_on": "Wrap long lines",
  "code.wrap_off": "Don't wrap lines",
  "code.dark": "Dark editor",
  "code.light": "Light editor",
  "code.download": "Download theme",
  "code.preview": "Preview",
  "code.publish": "Publish",
  "code.publish_title": "Publish this theme?",
  "code.publish_body": "{name} becomes your live theme. Shoppers see it right away.",
  "code.published": "Theme published",
  "code.save": "Save",
  "code.saved": "Saved",
  "code.saved_with_errors": "{n, plural, one {Saved with 1 error — fix it before publishing} other {Saved with # errors — fix them before publishing}}",
  "code.live_rejected": "The live theme can't be saved with errors, so your store keeps working. Fix the problems below.",
  "code.unsaved": "Unsaved changes",
  "code.close_tab": "Close {name}",
  "code.changed_by": "Changed by {who}",
  "code.load_theirs": "Load their version",
  "code.find": "Find and replace",
  "code.goto_line": "Go to line",
  "code.fold_all": "Fold all",
  "code.unfold_all": "Unfold all",
  "code.format_failed": "Couldn't format: {msg}",
  "code.problems": "Problems",
  "code.check_theme": "Check theme",
  "code.no_problems": "No problems found.",
  "code.search_all": "Search all files",
  "code.search_ph": "Text to find",
  "code.replace_ph": "Replace with",
  "code.match_case": "Match case",
  "code.search": "Search",
  "code.replace_all": "Replace all",
  "code.replace_all_title": "Replace in all files?",
  "code.replace_all_body": "{n} matches in {files} files are replaced in the editor. Nothing is saved until you save each file.",
  "code.replaced": "Replaced in {files} files — review and save them",
  "code.n_results": "{n} results in {files} files",
  "code.preview_page": "Page to preview",
  "code.page.home": "Home page",
  "code.page.product": "Product",
  "code.page.collection": "Collection",
  "code.page.cart": "Cart",
  "code.page.search": "Search",
  "code.page.page": "Page",
  "code.page.blog": "Blog",
  "code.page.404": "Page not found",
  "code.reload": "Reload",
  "code.open_new_tab": "Open in new tab",
  "code.close_preview": "Close preview",
  "code.preview_hint": "Shows saved changes and reloads after each save.",
  "code.open_asset": "Open file",
  "code.asset_hint": "Images, fonts and media can't be edited here. Upload a new file with the same name to replace it.",
  "code.uploaded": "Uploaded {name}",
  "code.empty_title": "Open a file to start editing",
  "code.empty_live": "This is your live theme: saves show in your store straight away, and files with errors can't be saved.",
  "code.empty_draft": "This theme isn't live. Preview your changes, then publish it when it's ready.",
  "code.leave_body": "Some files have unsaved changes. Leave without saving?",
  "code.discard_title": "Discard changes?",
  "code.discard_body": "Your changes to {path} aren't saved.",
  "code.discard": "Discard",
};
export default codeEn;
